// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { doc, collection, getDocs, getDoc, initializeFirestore, persistentLocalCache, persistentSingleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { GeoFirestore } from 'geofirestore';
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);

// const db = getFirestore(app);

// 🧠 Ativa logs detalhados (coloque aqui!)
// setLogLevel("debug");

const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentSingleTabManager()
  })
});

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const firestore = db;

const storage = getStorage(app)

const signInWithGoogle = () => {
  return signInWithPopup(auth, provider);
};

const geoFirestore = new GeoFirestore(firestore);

const functions = getFunctions(app);


export {
  db,
  doc,
  firestore,
  provider,
  collection,
  getDocs,
  getDoc,
  storage,
  auth,
  signInWithGoogle,
  geoFirestore,
  functions,
  analytics
};